import { ChangeEvent } from "react";
import { Grid } from "@mui/material";
import { useContextProfileContext } from "src/Contexts/ContextProfile/ContextProfile";
import { IUpdatePasswordProfile } from "src/Contexts/ContextProfile/ContextProfileTypes";
import { valuesDefaultUpdatePasswordProfile } from "src/Contexts/ContextProfile/ValuesDefaultContextProfile/ValuesDefaultContextProfile";
import { AppTextField, FormCore } from "src/Pages/components";

import { UseFormUpdateProfilePassword } from "./Hooks/UseFormUpdateProfilePassword";

export const FormProfilePassword = () => {
  const { setValuesUpdatePasswordProfile, valuesUpdatePasswordProfile } =
    useContextProfileContext();

  const { handleSubmit, loading: loadingUpdate } =
    UseFormUpdateProfilePassword();

  const handleChange =
    (prop: keyof IUpdatePasswordProfile) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      setValuesUpdatePasswordProfile((prevValue) => ({
        ...prevValue,
        [prop]: event.target.value,
      }));
    };

  return (
    <FormCore
      handleCancel={() =>
        setValuesUpdatePasswordProfile(valuesDefaultUpdatePasswordProfile)
      }
      handleSubmit={handleSubmit}
      loadingSubmit={loadingUpdate}
      sxStyle={{ margin: 0 }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <AppTextField
            label="Senha atual"
            sxStyle={{
              pointerEvents: "",
              width: "100%",
              opacity: "",
              margin: 0,
            }}
            value={valuesUpdatePasswordProfile?.password_currency}
            variant="outlined"
            onChange={handleChange("password_currency")}
          />
        </Grid>

        <Grid item xs={12}>
          <AppTextField
            label="Nova senha"
            sxStyle={{
              pointerEvents: "",
              width: "100%",
              opacity: "",
              margin: 0,
            }}
            value={valuesUpdatePasswordProfile?.password_new}
            variant="outlined"
            onChange={handleChange("password_new")}
          />
        </Grid>

        <Grid item xs={12}>
          <AppTextField
            label="Nova senha"
            sxStyle={{
              pointerEvents: "",
              width: "100%",
              opacity: "",
              margin: 0,
            }}
            value={valuesUpdatePasswordProfile?.password_new_repeat}
            variant="outlined"
            onChange={handleChange("password_new_repeat")}
          />
        </Grid>
      </Grid>
    </FormCore>
  );
};
